module.exports = __webpack_public_path__ + "static/media/step2.aa3f04dd.png";